export default __webpack_public_path__ + "static/banner-terceirizacao-34f3cd3412b2d174cca916f8e1bd7078.jpg";